"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("../../components/utils/helpers");
var _colors = require("../colors.config");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    '& .MuiList-padding': {
      paddingBottom: 6,
      paddingTop: 6
    },
    '& .MuiListItem-root.Mui-selected,.MuiListItem-root.Mui-selected:hover': {
      backgroundColor: isHighContrast ? _colors.Black[800] : _colors.Black[100]
    },
    '& .MuiMenuItem-root': {
      color: isHighContrast ? _colors.Black[50] : _colors.Black[290],
      fontSize: isFontBigger ? '20px' : '16px',
      fontWeight: '500',
      lineHeight: '20px',
      minHeight: '32px'
    },
    border: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
    marginTop: '6px'
  };
};
exports.default = _default;